/* Блок шаблонов. Ведёт себя как обычный раскрывающийся раздел: пока закрыт —
   одна строка, ничего не перекрывает и не всплывает поверх работы. */
.wrap {
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
}

.summary {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--sp-2) var(--sp-4);
  padding: var(--sp-4) var(--sp-5);
  cursor: pointer;
  /* Flex-строка съедает системный маркер, поэтому треугольник рисуем сами —
     иначе закрытый раздел выглядит просто строкой текста, и в него не жмут. */
  list-style: none;
}

.summary::-webkit-details-marker {
  display: none;
}

.summary::before {
  content: '';
  flex: none;
  align-self: center;
  width: 0;
  height: 0;
  border-left: 5px solid var(--text-3);
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  transition: transform var(--dnd-dur) var(--dnd-ease);
}

.wrap[open] > .summary::before {
  transform: rotate(90deg);
}

@media (prefers-reduced-motion: reduce) {
  .summary::before {
    transition: none;
  }
}

.summary:hover .summaryTitle {
  text-decoration: underline;
}

.summaryTitle {
  font-size: var(--fs-md);
  font-weight: 600;
}

.summaryHint {
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.note {
  padding: 0 var(--sp-5);
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: var(--sp-4);
  margin: 0;
  padding: var(--sp-4) var(--sp-5) var(--sp-5);
  list-style: none;
}

.cell {
  display: flex;
}

/* Карточка — одна большая кнопка: заголовок, строчка смысла, состав и действие. */
.card {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-3);
  padding: var(--sp-5);
  background: var(--surface-sunken);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  text-align: left;
  cursor: pointer;
  transition:
    background var(--dnd-dur) var(--dnd-ease),
    border-color var(--dnd-dur) var(--dnd-ease);
}

.card:hover:not(:disabled) {
  background: var(--surface-2);
  border-color: var(--border-strong);
}

.card:disabled {
  opacity: 0.5;
  cursor: progress;
}

@media (prefers-reduced-motion: reduce) {
  .card {
    transition: none;
  }
}

.name {
  font-size: var(--fs-lg);
  font-weight: 600;
}

.desc {
  color: var(--text-2);
  font-size: var(--fs-sm);
  line-height: 1.45;
}

/* Состав шаблона виден до нажатия: человек выбирает набор блоков, а не
   название, и должен понимать, что именно появится. */
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  padding: 1px var(--sp-3);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  background: var(--surface);
  color: var(--text-2);
  font-size: var(--fs-xs);
  white-space: nowrap;
}

.chipCount {
  color: var(--text-3);
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
}

.action {
  margin-top: auto;
  padding-top: var(--sp-2);
  color: var(--text);
  font-size: var(--fs-sm);
  font-weight: 600;
}

@media (max-width: 720px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
